export const FETCH_USERS = 'fetch_users';
export const fetchUsers = () => async (dispatch, getState, axiosInstance) => {
    // const res = await axios.get('http://react-ssr-api.herokuapp.com/users'); 
    const res = await axiosInstance.get('/users');
    dispatch({
        type: FETCH_USERS,
        payload: res
    });
}

export const FETCH_PAGE_INFO = 'fetch_page_info';
export const fetchPageInfo = () => async (dispatch, getState, axiosInstance) => {
    const res = await axiosInstance.get('/page_info');
    dispatch({
        type: FETCH_PAGE_INFO,
        payload: res
    });
}

export const FETCH_CURRENT_USER = 'fetch_current_user';
export const fetchCurrentUser = () => async (dispatch, getState, axiosInstance) => {
    const res = await axiosInstance.get('/current_user');
    dispatch({
        type: FETCH_CURRENT_USER,
        payload: res
    });
}

export const FETCH_ADMINS = 'fetch_admins';
export const fetchAdmins = () => async (dispatch, getState, axiosInstance) => {
    const res = await axiosInstance.get('/admins');
    dispatch({
        type: FETCH_ADMINS,
        payload: res
    });
}


export const FETCH_TOUR = 'fetch_tour';
export const fetchTour = () => async (dispatch, getState, axiosInstance) => {
    const res = await axiosInstance.get('/tour');
    dispatch({
        type: FETCH_TOUR,
        payload: res
    });
}

export const FETCH_ROOMS = 'fetch_rooms';
export const fetchRooms = () => async (dispatch, getState, axiosInstance) => {
     let res = await axiosInstance.get('/rooms');
    dispatch({
        type: FETCH_ROOMS,
        payload: res
    });
}

export const FETCH_FACILITIES = 'fetch_facilities';
export const fetchFacilities = () => async (dispatch, getState, axiosInstance) => {
     let res = await axiosInstance.get('/facilities');
    dispatch({
        type: FETCH_FACILITIES,
        payload: res
    });
}


export const FETCH_CARES = 'fetch_cares';
export const fetchCares = () => async (dispatch, getState, axiosInstance) => {
    let res = await axiosInstance.get('/cares');
   dispatch({
       type: FETCH_CARES,
       payload: res
   });
}

export const FETCH_NEWS = 'fetch_news';
export const fetchNews = () => async (dispatch, getState, axiosInstance) => {
    let res = await axiosInstance.get('/news');
   dispatch({
       type: FETCH_NEWS,
       payload: res
   });
}

export const FETCH_CORE = 'fetch_core';
export const fetchCore = () => async (dispatch, getState, axiosInstance) => {
    let res = await axiosInstance.get('/core');
   dispatch({
       type: FETCH_CORE,
       payload: res
   });
}

export const FETCH_HOME = 'fetch_home';
export const fetchHome = () => async (dispatch, getState, axiosInstance) => {
    let res = await axiosInstance.get('/home');
   dispatch({
       type: FETCH_HOME,
       payload: res
   });
}

export const FETCH_CONTACTUS = 'fetch_contactus';
export const fetchContactus = () => async (dispatch, getState, axiosInstance) => {
    let res = await axiosInstance.get('/contactus');
   dispatch({
       type: FETCH_CONTACTUS,
       payload: res
   });
}

export const FETCH_EDUCATIONS = 'fetch_educations';
export const fetchEducations = () => async (dispatch, getState, axiosInstance) => {
  let res = await axiosInstance.get('/educations');
  dispatch({
    type: FETCH_EDUCATIONS,
    payload: res
  });
}








// WEBPACK FOOTER //
// ./src/client/actions/index.js